export default __webpack_public_path__ + "static/media/cf.290bd76f.svg";